<div class="playlistbanner-top">
      <div class="playlistbanner-block" *ngIf="playlistbanner?.stream">
            <img class="track-image" [src]="playlistbanner.stream.image" alt="Description" />

      </div>

      <div class="playlistbanner-block">
                  <div class="track-title" *ngIf="playlistbanner?.stream">
                        {{ playlistbanner.stream.title}}
                  </div>
                  <div class=player-link>
                        <a href="/wp-content/plugins/scorpio-player-f0001/web-app/">
                              <div class="player-link-details">
                                    <mat-icon class="stream-icon" aria-hidden="false"
                                          aria-label="Example home icon" fontIcon="volume_up">
                                    </mat-icon>
                                    <div class="stream-link">Luister naar de stream</div>
                              </div>
                        </a>
                  </div>
      </div>
      
     
</div>